import * as React from "react";
import Svg, { Rect } from "react-native-svg";
import { IconlyIconProps } from "./interface";

const Russia = ({ size = 640 }: IconlyIconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={(size / 640) * 400}
    viewBox="0 0 8 5"
  >
    {/* Border */}
    <Rect
      x={0}
      y={0}
      width={8}
      height={5}
      stroke="#000"
      strokeWidth={0.1}
      fill="none"
    />

    {/* Top stripe (white) */}
    <Rect width={8} height={5} fill="#fff" />

    {/* Middle stripe (blue) */}
    <Rect y={5 / 3} width={8} height={5 / 3} fill="#0039a6" />

    {/* Bottom stripe (red) */}
    <Rect y={(5 / 3) * 2} width={8} height={5 / 3} fill="#d52b1e" />
  </Svg>
);

export default Russia;
